var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_554_1182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9864 2.01863C20.0839 1.56477 19.6389 1.18208 19.2049 1.3477L0.376938 8.53513C0.266244 8.57739 0.170964 8.65222 0.10367 8.74975C0.0363756 8.84727 0.000229553 8.96291 1.08972e-06 9.08139C-0.000227373 9.19988 0.0354724 9.31565 0.10239 9.41344C0.169308 9.51122 0.264299 9.58642 0.374829 9.6291L5.66396 11.6719V18.1059C5.66395 18.2377 5.7084 18.3657 5.79014 18.4692C5.87188 18.5726 5.98611 18.6455 6.11438 18.676C6.24265 18.7065 6.37746 18.6928 6.497 18.6372C6.61655 18.5816 6.71385 18.4873 6.77317 18.3696L8.96068 14.0287L14.2991 17.9905C14.6238 18.2315 15.0905 18.0782 15.2087 17.6909C20.193 1.34899 19.9775 2.05969 19.9864 2.01863ZM15.3387 4.07791L6.16684 10.6098L2.22048 9.08571L15.3387 4.07791ZM6.83582 11.5721L14.8306 5.87848C7.9512 13.1358 8.31049 12.7538 8.28049 12.7942C8.23592 12.8542 8.35803 12.6205 6.83582 15.6412V11.5721ZM14.3302 16.5543L9.63118 13.067L18.1276 4.10369L14.3302 16.5543Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_554_1182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanin);
export default __webpack_public_path__ + "static/media/planin.9d2cbc92fada01dfe719828a1d4f2d61.svg";
export { ForwardRef as ReactComponent };